import { SessionOptions } from "~/modules/session";

const defaultSessionOptions: SessionOptions = {
    autoUpdateToken: false
};

export function getDefaultSessionOptions(): SessionOptions {
    return defaultSessionOptions;
}
